module.exports = __webpack_public_path__ + "assets/images/10H.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/10H.png
// module id = 1279
// module chunks = 1